export enum RemoteJudgeType {
  DidaOJ = 0,
  Hdu = 1,
  Poj = 2,
  Zznu = 3,
  Haut = 4,
  Codeforces = 5,
  Max,
}

export function GetRemoteJudgeTypeByStr(typeStr: string) {
  if (!typeStr) {
    return RemoteJudgeType.DidaOJ;
  }
  switch (typeStr.toLowerCase()) {
    case "didaoj":
      return RemoteJudgeType.DidaOJ;
    case "hdu":
      return RemoteJudgeType.Hdu;
    case "poj":
      return RemoteJudgeType.Poj;
    case "zznu":
      return RemoteJudgeType.Zznu;
    case "haut":
      return RemoteJudgeType.Haut;
    case "codeforces":
      return RemoteJudgeType.Codeforces;
    default:
      return RemoteJudgeType.DidaOJ;
  }
}

export function GetRemoteJudgeTypeStr(type: RemoteJudgeType) {
  switch (type) {
    case RemoteJudgeType.DidaOJ:
      return "DidaOJ";
    case RemoteJudgeType.Hdu:
      return "HDU";
    case RemoteJudgeType.Poj:
      return "POJ";
    case RemoteJudgeType.Zznu:
      return "ZZNU";
    case RemoteJudgeType.Haut:
      return "HAUT";
    case RemoteJudgeType.Codeforces:
      return "Codeforces";
    default:
      return "";
  }
}

export function GetRemoteJudgeTypeOptions() {
  const exclude = [RemoteJudgeType.Max];
  return Object.values(RemoteJudgeType)
    .filter((v) => typeof v === "number" && !exclude.includes(v))
    .map((value) => ({
      value,
      label: GetRemoteJudgeTypeStr(value as RemoteJudgeType),
    })) as { label: string; value: RemoteJudgeType }[];
}
